import React, { useEffect, useState } from "react";
import {formatStackedGraphData, getLastFiveMonthList} from "../../../utilities/graphData";
import { getSignUps } from "../../../services/signUpService";
import EnrolmentBarChart from "./EnrolmentBarChart";
import {Spin} from "antd";

const MonthlyBarChartWrapper = () => {
  const monthList = getLastFiveMonthList();
  const [signUpList, setSignupList] = useState({
    0: null,
    1: null,
    2: null,
  });

  const [loading, setLoading] = useState(false);
  const [index, setIndex] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [loadGraph, setLoadGraph] = useState(false)

  const paramList = [
    {
      dropOuts: "basicInfo",
    },
    {
      dropOuts: "paymentInfo",
    },
    {
      enrolled: 1,
    },
  ];

  const chartLabels = monthList.map((m) => m.monthName);
  const options = {
    scales: {
      yAxes: [
        {
          stacked: true,
          ticks: {
            beginAtZero: true,
          },
        },
      ],
      xAxes: [
        {
          stacked: true,
        },
      ],
    },
  };
  const paramNames = ["Basic Info Only", "Payment Info Only", "Enrolled"];
  const paramColors = [
    "rgb(255, 99, 132)",
    "rgb(54, 162, 235)",
    "rgb(75, 192, 192)",
  ];

  const getData = (param, index) => {
    const fetches = [];

    let signUpNumber = [];
    let total = 0;

    monthList.forEach(async (m, i) => {
      const filter = {
        month: m.month,
        year: m.year,
        countOnly: true,
      };

      fetches.push(
        await getSignUps(1, 2, { ...param, ...filter })
          .then((response) => {
            const count = response.data.totalCount;
            total = totalCount + count;
            signUpNumber[i] = count;
          })
          .catch((err) => console.log(err))
      );
    });

    // Wait for all fetches to finish
    Promise.all(fetches).then(function () {
      let currentSignupList = signUpList;
      currentSignupList[index] = signUpNumber;
      setSignupList(currentSignupList);
      let currentTotal = totalCount;
      currentTotal = currentTotal + total;
      setTotalCount(currentTotal);
      setIndex(index + 1);
    });
  };

  useEffect(() => {
    setLoading(true);
    paramList.forEach(async (param, index) => {
      await getData(param, index);
    });
    setLoading(false);
    setTimeout(() => {setLoadGraph(true)}, 1000)
  }, []);


  if (!loading && loadGraph && index === paramList.length) {
    let graphValue = formatStackedGraphData(signUpList, paramNames, paramColors, chartLabels);
      return <div>
        <EnrolmentBarChart
            data={graphValue}
            options={options}
            title="Last 5 months"
        />
      </div>;

  } else if (!loadGraph) {
    return <Spin />
  }
  else {
    return <div>No record found</div>;
  }
};

export default MonthlyBarChartWrapper;
